import { createPortal } from 'react-dom';
import styled from 'styled-components';

import PopoverPicker from '@components/popoverPicker/PopoverPicker';
import Checkbox from '../sidebars/sidebarElements/LayerCheckbox';
import { useProject } from '@contexts/Project.context';
import useDebounce from '@hooks/useDebounce';
import SidebarTemplate from '../sidebars/sidebarElements/SidebarTemplate';

const FilterContainer = styled.div`
	padding: 20px 20px 200px;
`;
const SidebarRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 50px;
	align-items: center;
	&:hover {
		cursor: pointer;
		color: white;
	}
`;
const PopoverHolder = styled.div`
	position: relative;
`;

// REVIEW: This should probably be renamed and or merged with ModifyPoints.jsx
const ModifyPoint = ({ className, color }) => {
	if (!color) return null;

	const { trainingDataClassNameInfo, dispatch } = useProject();

	const changeColor = useDebounce(color => {
		dispatch({
			type: 'setTrainingDataClassNameInfo',
			payload: {
				...trainingDataClassNameInfo,
				[className]: {
					...trainingDataClassNameInfo[className],
					color: color,
				},
			},
		});
	}, 300); // 300ms debounce time

	return <PopoverPicker color={color} onChange={changeColor} popDirection="right" />;
};

const TrainingDataPalette = ({}) => {
	const { modifyLayersSidebarRef, trainingDataClassNameInfo, dispatch } = useProject();
	if (!trainingDataClassNameInfo || !modifyLayersSidebarRef?.current) return null;

	const dispatchVisibility = (trainingDataClassNameInfo, className, visible) => {
		dispatch({
			type: 'setTrainingDataClassNameInfo',
			payload: {
				...trainingDataClassNameInfo,
				[className]: {
					...trainingDataClassNameInfo[className],
					visible: visible,
				},
			},
		});
	};

	return (
		<>
			{createPortal(
				<SidebarTemplate
					sidebarId="trainingDataPalette"
					header="Modify Palette"
					zindex={2}
					closeable>
					<FilterContainer>
						{Object.entries(trainingDataClassNameInfo).map(
							([className, { color, visible }], index) => (
								<div key={`td-${index}`}>
									<SidebarRow>
										<Checkbox
											id={`td-${index}`}
											label={className === 'null' ? 'Unlabeled' : className}
											defaultState={visible}
											onCheck={() => {
												dispatchVisibility(
													trainingDataClassNameInfo,
													className,
													true
												);
											}}
											onUncheck={() => {
												dispatchVisibility(
													trainingDataClassNameInfo,
													className,
													false
												);
											}}
										/>
										<PopoverHolder>
											<ModifyPoint className={className} color={color} />
										</PopoverHolder>
									</SidebarRow>

									<hr className="my-3" />
								</div>
							)
						)}
					</FilterContainer>
				</SidebarTemplate>,
				modifyLayersSidebarRef?.current
			)}
		</>
	);
};

export default TrainingDataPalette;
